import { render, staticRenderFns } from "./SlideTitle.vue?vue&type=template&id=a586ed42&scoped=true&"
import script from "./SlideTitle.vue?vue&type=script&lang=js&"
export * from "./SlideTitle.vue?vue&type=script&lang=js&"
import style0 from "./SlideTitle.vue?vue&type=style&index=0&id=a586ed42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a586ed42",
  null
  
)

export default component.exports